import {
  ApiBlueprint,
  createFrontendModule,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/frontend-plugin-api';
import { scmIntegrationsApiRef } from '@backstage/integration-react';
import { ScaffolderClient } from '@backstage/plugin-scaffolder-common';
import { scaffolderApiRef } from '@backstage/plugin-scaffolder-react';

export const scaffolderApiModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    ApiBlueprint.make({
      name: 'scaffolder-client',
      params: defineParams =>
        defineParams({
          api: scaffolderApiRef,
          deps: {
            discoveryApi: discoveryApiRef,
            scmIntegrationsApi: scmIntegrationsApiRef,
            fetchApi: fetchApiRef,
            identityApi: identityApiRef,
          },
          factory: ({
            discoveryApi,
            scmIntegrationsApi,
            fetchApi,
            identityApi,
          }) =>
            new ScaffolderClient({
              discoveryApi,
              scmIntegrationsApi,
              fetchApi,
              identityApi,
              useLongPollingLogs: true,
            }),
        }),
    }),
  ],
});
